{
    "DataTable_AreYouSure": "Vuoi davvero eliminare quanto segue? \n \n **{}**",
    "NAME": "LanguageDataTable",
    "DataTable_RowsPerPage": "Righe per pagina",
    "DataTable_Of": "{}-{} of {}",
    "DataTable_Next": "Pagina successiva",
    "DataTable_Previous": "Pagina precedente",
    "DataTable_OfMoreThan": "{}-{} di più di {}"
}